/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable import/prefer-default-export */
import { CreateAxiosInstace, GetToken } from './utils.service';

const Token = GetToken();

export const defaultUrlCapNegocios = () =>
    `${sessionStorage.getItem('CAPNEGOCIOS_API_URL')}/api`;

export const CapNegociosAPI = CreateAxiosInstace(Token);
